import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify';

function BuyingUpdate() {

    const navigate = useNavigate()
    const params = useParams();
    const id = params.id;

    const [formData, setFormData] = useState({
        name: "",
        contact: 0,
        address: "",
        paymentMethod: "",
        date: ""
    });

    const [buying, setBuying] = useState([]);
    useEffect(() => {
        (async () => {
            try {
                const response = await axios.get(`/buy/${id}`);
                if (response.data.success) {
                    setBuying(response.data.buying);

                    let data = response.data.buying;
                    setFormData({
                        name: data.distributor.name,
                        contact: data.distributor.contact,
                        address: data.distributor.address,
                        paymentMethod: data.distributor.paymentMethod,
                        date: data.distributor.date
                    });
                }
            } catch (error) {
                toast.error(error.response.data.message);
            }
        })();
    }, [])


    const handleChange = (e) => {
        let { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    }


    const handleSubmit = async (e) => {
        e.preventDefault();

        let postData = {
            distributor: {
                name: formData.name,
                contact: formData.contact,
                address: formData.address
            },
            paymentMethod: formData.paymentMethod,
            date: formData.date
        }

        try {
            const response = await axios.put(`/buy/${id}`, postData);
            if (response.data.success) {
                toast.success(response.data.message);
                navigate("/buying")
            }
        } catch (error) {
            toast.error(error.response.data.message);
        }
    }

    return (
        <>
            <h1 className='text-2xl font-bold text-center mt-4'>Update purchasing details</h1>
            <div className='flex justify-center items-center'>

                <form onSubmit={handleSubmit} className='space-y-3 border border-blue-600 p-4 rounded-lg mt-6 shadow-2xl'>
                    <div>
                        <label htmlFor="name">Distributor name</label>
                        <input
                            type="text"
                            id='name'
                            value={formData.name}
                            onChange={handleChange}
                            name='name'
                            placeholder=""
                            className="input input-bordered input-accent w-full" />
                    </div>

                    <div>
                        <label htmlFor="contact">Contact</label>
                        <input
                            type="text"
                            id='contact'
                            value={formData.contact}
                            onChange={handleChange}
                            name='contact'
                            placeholder=""
                            className="input input-bordered input-accent w-full" />
                    </div>

                    <div>
                        <label htmlFor="address">Address</label>
                        <input
                            type="text"
                            id='address'
                            value={formData.address}
                            onChange={handleChange}
                            name='address'
                            placeholder=""
                            className="input input-bordered input-accent w-full" />
                    </div>

                    <div>
                        <label htmlFor="">Payment Method</label>
                        <select name="paymentMethod" value={formData.paymentMethod}
                            onChange={handleChange}
                            className="select select-accent w-full">
                            <option value="" selected>Select Payment Method</option>
                            <option value="CASH">CASH</option>
                            <option value="UPI">UPI</option>
                            <option value="CARD">CARD</option>
                            <option value="NEFT">NEFT</option>
                        </select>
                    </div>

                    <div>
                        <label htmlFor="date">Date</label>
                        <input
                            type="date"
                            value={formData.date}
                            onChange={handleChange}
                            id='date'
                            name='date'
                            placeholder=""
                            className="input input-bordered input-accent w-full" />
                    </div>

                    <div className='text-center'>
                        <button type='submit' className="btn btn-outline btn-primary">Submit</button>
                    </div>
                </form>
            </div>

        </>
    )
}

export default BuyingUpdate
